import { useEffect, useState } from 'react';
import Header from '../componets/headerwebsite/headerweb';
import FooterWeb from '../componets/footerwebsite/footerweb';
import bank from '../../assets/qr.jpg';
import { Button, Card, Form, Input, notification } from 'antd';
import { API } from '../../config/api';
import { GET, POST } from '../../utils/apicalls';
import { useParams } from 'react-router-dom';
import './bookingproduct.css';
import { Col, Row } from 'react-bootstrap';

import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Initialize dayjs plugins for timezone handling
dayjs.extend(utc);
dayjs.extend(timezone);

function Bookingproduct() {
    const [data, setData] = useState<any>([]);
    const [offerData, setOfferData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const { id } = useParams();

    const fetchOneProduct = async () => {
        try {
            setIsLoading(true);
            const api = API.GET_ONE_PRODUCT + id;
            const response: any = await GET(api, {});
            setData(response?.data);
            form.setFieldsValue(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchofferproduct = async () => {
        try {
            setIsLoading(true);
            const url = API.LISTOFFER_ACTIVE_PRODUCTID + id;
            const response: any = await POST(url, {});

            // Convert UTC times to local timezone for display
            const formattedData = response?.data?.map((item: any) => ({
                ...item,
                Offer_start_time: item.Offer_start_time ? dayjs.utc(item.Offer_start_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : '',
                Offer_End_time: item.Offer_End_time ? dayjs.utc(item.Offer_End_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : ''
            }));

            setOfferData(formattedData);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const submitHandler = async (values: any) => {
        try {
            // Get the active offer price (if available)
            const activeOffer = offerData?.length > 0 ? offerData[0] : null;
            const offerPrice = activeOffer ? activeOffer.Offer_price : null;

            let obj = {
                productid: Number(id),
                Buyername: values.Buyername,
                Buyeremail: values.Buyeremail,
                Buyermobile_number: values.Buyermobile_number,
                Buyeraddress: values.Buyeraddress,
                Buyermessage: values.Buyermessage,
                orderdate: new Date().toISOString(),
                bookingstatus: "pending",
                // offerPrice: offerPrice, // Pass the offer price in the booking data
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_BOOKING_DATA, obj);

            if (postRequest.status) {
                notification.success({ message: "Booked successfully!" });
                form.resetFields();
                sendToWhatsApp(obj, offerPrice);
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const sendToWhatsApp = (bookingData: any, offerPrice: any) => {
        let phoneNumber = "+919995782784"; // Replace with actual WhatsApp number

        let message = `New Booking:%0A
        Name: ${bookingData.Buyername}%0A
        Mobile: ${bookingData.Buyermobile_number}%0A
        Email: ${bookingData.Buyeremail}%0A
        Address: ${bookingData.Buyeraddress}%0A
        Product: ${data?.productTitle}%0A
        Message: ${bookingData.Buyermessage}%0A
        ${offerPrice ? `Offer Price: ₹${offerPrice}` : `Regular Price: ₹${data?.Price}`}`;

        let whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
        window.open(whatsappURL, "_blank");
    };

    useEffect(() => {
        fetchOneProduct();
        fetchofferproduct();
    }, []);

    return (
        <div>
            <Header />
            <div className='product-booking-page'>
                <Card className='booking-data-page'>
                    <img src={bank} alt='bank account' />
                    <p> State Bank Of India</p>
                    <p>0317053000009312</p>
                    <p>Ifsc code: SIBL0000317</p>
                    <p>Google pay : +91 6235505404</p>
                    <Card className='booking-form-page'>
                        <h3>BOOK NOW</h3>
                        <Form form={form} onFinish={submitHandler} layout="vertical">
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item name="productTitle" label="Product Title">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item name="Buyername" label="Full Name" rules={[{ required: true }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        name="Buyeremail"
                                        label="Email"
                                        rules={[
                                            { required: true, message: "Please enter your email" },
                                            { type: "email", message: "Please enter a valid email" },
                                        ]}
                                    >
                                        <Input type="email" placeholder="Enter your email" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item name="Buyermobile_number" label="Contact Number" rules={[{ required: true }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item name="Buyeraddress" label="Address" rules={[{ required: true }]}>
                                        <Input.TextArea />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item name="Buyermessage" label="Messages" rules={[{ required: true }]}>
                                        <Input.TextArea />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Button type="primary" htmlType="submit" block>
                                Submit
                            </Button>
                        </Form>
                    </Card>
                </Card>
            </div>
            <FooterWeb />
        </div>
    );
}

export default Bookingproduct;
